import { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

export default function GenderSelectBox(props) {
  const { gender, setGender, isColorSubKey = false } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const activeColor = isColorSubKey ? theme.subKey : theme.primary;

  const MaleButtonRef = useRef();
  const MaleTextRef = useRef();
  const FemaleButtonRef = useRef();
  const FemaleTextRef = useRef();

  useEffect(() => {
    if (gender === 'male') {
      MaleButtonRef.current.style.backgroundColor = activeColor;
      MaleButtonRef.current.style.border = `1px solid ${activeColor}`;
      MaleTextRef.current.style.color = theme.subBackground;
      FemaleButtonRef.current.style.backgroundColor = theme.subBackground;
      FemaleButtonRef.current.style.border = `1px solid ${theme.line}`;
      FemaleTextRef.current.style.color = theme.subText;
    }
    else if (gender === 'female') {
      MaleButtonRef.current.style.backgroundColor = theme.subBackground;
      MaleButtonRef.current.style.border = `1px solid ${theme.line}`;
      MaleTextRef.current.style.color = theme.subText;
      FemaleButtonRef.current.style.backgroundColor = activeColor;
      FemaleButtonRef.current.style.border = `1px solid ${activeColor}`;
      FemaleTextRef.current.style.color = theme.subBackground;
    }
  }, [gender, theme, activeColor])

  return(
    <TopLevelWrapper>
      <Button ref={MaleButtonRef} onClick={() => setGender('male')}>
        <ButtonText ref={MaleTextRef}>{t('memberRegistration.genderSelectBox.male')}</ButtonText>
      </Button>
      <Button ref={FemaleButtonRef} onClick={() => setGender('female')}>
        <ButtonText ref={FemaleTextRef}>{t('memberRegistration.genderSelectBox.female')}</ButtonText>
      </Button>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direcion: row;

  justify-content: center;
  align-items: center;

  gap: 5px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;

  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;
`;
